export const mockFeatureFlags = [
    {
        featureName: 'Dark Mode Toggle',
        featureDescription: 'Enable dark mode theme across the application Enable dark mode theme across the application Enable dark mode theme across the application Enable dark mode theme across the application Enable dark mode theme across the application Enable dark mode theme across the application ',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'AD Groups',
                variant: 'secondary',
                className: 'bg-blue-100 text-blue-800 border-blue-200'
            },
            {
                text: 'Everyone',
                variant: 'outline',
                className: 'bg-green-100 text-green-800 border-green-200'
            },
            {
                text: 'Users',
                variant: 'secondary',
                className: 'bg-purple-100 text-purple-800 border-purple-200'
            }
        ],
        featureEnabled: {
            checked: true,
            disabled: false,
            id: 'toggle-dark-mode',
            label: '',
            value: 'dark-mode'
        },
        featureActions: ''
    },
    {
        featureName: 'Enhanced Search',
        featureDescription: 'Advanced search functionality with filters and sorting',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'AD Groups',
                variant: 'secondary',
                className: 'bg-blue-100 text-blue-800 border-blue-200'
            }
        ],
        featureEnabled: {
            checked: false,
            disabled: false,
            id: 'toggle-enhanced-search',
            label: '',
            value: 'enhanced-search'
        },
        featureActions: ''
    },
    {
        featureName: 'Real-time Notifications',
        featureDescription: 'Push notifications for real-time updates and alerts',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'Everyone',
                variant: 'outline',
                className: 'bg-green-100 text-green-800 border-green-200'
            },
            {
                text: 'Users',
                variant: 'secondary',
                className: 'bg-purple-100 text-purple-800 border-purple-200'
            }
        ],
        featureEnabled: {
            checked: true,
            disabled: false,
            id: 'toggle-realtime-notifications',
            label: '',
            value: 'realtime-notifications'
        },
        featureActions: ''
    },
    {
        featureName: 'Analytics Dashboard',
        featureDescription: 'Comprehensive analytics and reporting dashboard',
        featureTarget: '',
        targetingBadges: [],
        featureEnabled: {
            checked: false,
            disabled: false,
            id: 'toggle-analytics-dashboard',
            label: '',
            value: 'analytics-dashboard'
        },
        featureActions: ''
    },
    {
        featureName: 'Multi-language Support',
        featureDescription: 'Internationalization support for multiple languages',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'AD Groups',
                variant: 'secondary',
                className: 'bg-blue-100 text-blue-800 border-blue-200'
            },
            {
                text: 'Everyone',
                variant: 'outline',
                className: 'bg-green-100 text-green-800 border-green-200'
            },
            {
                text: 'Users',
                variant: 'secondary',
                className: 'bg-purple-100 text-purple-800 border-purple-200'
            }
        ],
        featureEnabled: {
            checked: true,
            disabled: false,
            id: 'toggle-multi-language',
            label: '',
            value: 'multi-language'
        },
        featureActions: ''
    },
    {
        featureName: 'Advanced User Permissions',
        featureDescription: 'Granular user role and permission management system',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'Users',
                variant: 'outline',
                className: 'bg-purple-100 text-purple-800 border-purple-200'
            }
        ],
        featureEnabled: {
            checked: false,
            disabled: false,
            id: 'toggle-advanced-permissions',
            label: '',
            value: 'advanced-permissions'
        },
        featureActions: ''
    },
    {
        featureName: 'Export Data Feature',
        featureDescription: 'Allow users to export data in various formats (CSV, PDF, Excel)',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'AD Groups',
                variant: 'secondary',
                className: 'bg-blue-100 text-blue-800 border-blue-200'
            },
            {
                text: 'Everyone',
                variant: 'outline',
                className: 'bg-green-100 text-green-800 border-green-200'
            }
        ],
        featureEnabled: {
            checked: true,
            disabled: false,
            id: 'toggle-export-data',
            label: '',
            value: 'export-data'
        },
        featureActions: ''
    },
    {
        featureName: 'Mobile App Integration',
        featureDescription: 'Seamless integration with mobile application features',
        featureTarget: '',
        targetingBadges: [],
        featureEnabled: {
            checked: false,
            disabled: false,
            id: 'toggle-mobile-integration',
            label: '',
            value: 'mobile-integration'
        },
        featureActions: ''
    },
    {
        featureName: 'Auto-save Functionality',
        featureDescription: 'Automatically save user work to prevent data loss',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'Everyone',
                variant: 'outline',
                className: 'bg-green-100 text-green-800 border-green-200'
            }
        ],
        featureEnabled: {
            checked: true,
            disabled: false,
            id: 'toggle-auto-save',
            label: '',
            value: 'auto-save'
        },
        featureActions: ''
    },
    {
        featureName: 'Beta Features Access',
        featureDescription: 'Early access to experimental and beta features',
        featureTarget: '',
        targetingBadges: [
            {
                text: 'AD Groups',
                variant: 'secondary',
                className: 'bg-blue-100 text-blue-800 border-blue-200'
            },
            {
                text: 'Users',
                variant: 'outline',
                className: 'bg-purple-100 text-purple-800 border-purple-200'
            }
        ],
        featureEnabled: {
            checked: false,
            disabled: false,
            id: 'toggle-beta-features',
            label: '',
            value: 'beta-features'
        },
        featureActions: ''
    }
];
